import { AxiosInstance } from 'axios';
import { CommunicationBookDisplayAdministratorRepository } from '@/model/repository/manager/communicationBookDisplayAdministrator/CommunicationBookDisplayAdministratorRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): CommunicationBookDisplayAdministratorRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
    create(payload) {
      return Repository.post(`${resource}`, payload);
    },
  });
